// ControlPrintButtonFactory.js
import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import PrintButtonControlView from 'advanced-visuals/PrintButtonControlView.js';

//=============================================================================
//
// Creates a print button control, given a factoryService
// parameter key and a layout postion. The factory key defines the initial
// rectangle of the control via a width and height from the factory parameter.
//
// -Maty Rocha, February 23, 2016
//
//=============================================================================
class ControlPrintButtonFactory extends BaseVisualControlFactory {
    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes(  factoryKey, pos ) ;


        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.text = 'Print';
        attributes.borderStyle = 'solid';

        attributes.buttonStyle ='~buttonStyle';
        attributes.styleColorText ='~buttonTextColor';
        attributes.styleColorTextDown ='~buttonTextDownColor';
        attributes.styleColorTextOver ='~buttonTextOverColor';
        attributes.fontFamily = '~buttonFont';
        attributes.fontSize = '~buttonFont';
        attributes.textWeight = '~buttonFont';
        attributes.textStyle  = '~buttonFont';
        attributes.cornerRadius= '~buttonRadius';
        attributes.borderColor = '~buttonBorderColor';
        attributes.backgroundColor = '~buttonBgColor';
        attributes.advancedBgGradientColor = '~buttonBgGradientColor';
        attributes.advancedBgColorOver = '~buttonBgOverColor';
        attributes.advancedBgGradientColorOver = '~buttonBgGradientOverColor';
        attributes.advancedBgColorDown = '~buttonBgDownColor';
        attributes.advancedBgGradientColorDown = '~buttonBgGradientDownColor';
        attributes.pageIds = '';
        attributes.appendixSizePreset = 'letter';
        attributes.appendixWidth = '612';
        attributes.appendixUnit = 'inch';
        attributes.appendixHeight = '792';
        attributes.appendixDpi = '72';
		attributes.inlineEditable = true;
        attributes.resizePadding = 2;
        attributes.resizePaddingH = 0;
		attributes.minWidth = 10;
        attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);
        attributes.translateProps = [
            {key:"text", label:"Text"},
            {key:"toolTip", label:"Tooltip"}
        ];

        return new PrintButtonControlView( { model: new ControlModel( attributes ), el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );
    }

}

const controlPrintButtonFactory = new ControlPrintButtonFactory();
export default controlPrintButtonFactory;
